import {
  Page,
  Section
} from "@app/components";
import Special_01 from '@assets/special/Special_01.png';
import Fireworks from '@assets/special/Fireworks.mp3';
import { doStuff, doMoreStuff } from './Fireworks';

export const Special = () => {
  const fireworksDisplay = () => {
    doStuff();
  };

  const heartsDisplay = () => {
    doMoreStuff();
  };

  const clickFireworks = () => {
    let audio = new Audio(Fireworks);
    audio.currentTime = 40;
    audio.loop = false;
    audio.play();
  }

  return (
    <Page name="home" heading="Hello Darling!">
      <Section name="content">
        <span
          style={{
            width: "clamp(400px, 50vw, 100%)",
            fontSize: "clamp(10px, 2vw, 20px)",
            display: "inline-block"
          }}
        >
          <p>
            This is an important page dedicated to someone very special to me...
          </p>
          <p className="will-fade-in" style={{
            animationDelay: "6s"
          }}>
            Our story started before we even met...
          </p>
          <p className="will-fade-in" style={{
            animationDelay: "12s"
          }}>
            <img width={256} height={256} src={Special_01} alt=""/>
            <br />
            And yet...our hearts found one another after the birth of a little girl.
          </p>
          <p className="will-fade-in" style={{
            animationDelay: "22s"
          }}>
            I started falling for you before I even knew you because your kind gestures from the heart brought us together...
          </p>
          <p className="will-fade-in" style={{
            animationDelay: "32s"
          }}>
            Everyday we're together I grow more as a person and love you deeper.
          </p>
          <p className="will-fade-in" style={{
            animationDelay: "40s"
          }}>
            Thank you for being in my life and...
          </p>
          <div className="will-fade-in" style={{
            animationDelay: "50s"
          }}>
            <p>Have a very... <br/><br/></p>
            <h1>Happy Birthday!</h1>
            <canvas onClick={clickFireworks} id="birthday" style={{maxWidth: "50vw"}} ref={() => fireworksDisplay()}></canvas>
          </div>
          <div className="will-fade-in" style={{
            animationDelay: "70s"
          }}>
            <div id="hearts" style={{maxWidth: "50vw"}} ref={() => heartsDisplay()}>
              <p style={{alignSelf: "start", marginTop: "40px"}}>I love you!!</p>
              <div className="cake">
                <div className="plate"></div>
                <div className="layer layer-bottom"></div>
                <div className="layer layer-middle"></div>
                <div className="layer layer-top"></div>
                <div className="icing"></div>
                <div className="drip drip1"></div>
                <div className="drip drip2"></div>
                <div className="drip drip3"></div>
                <div className="candle">
                    <div className="flame"></div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="will-fade-in" style={{
            animationDelay: "80s"
          }}>
            <p>and I have one last special surprise for you...</p>
          </div>
          <div className="will-fade-in" style={{
            animationDelay: "85s"
          }}>
            <p>Erin Herrick... you are so strong, smart, kind, and loving, I'm so proud of you, thank you for everything you do and...</p>
          </div>
          <div className="will-fade-in" style={{
            animationDelay: "90s"
          }}>
            <p>I was wondering if you would marry me?</p>
          </div>
        </span>
      </Section>
    </Page>
  );
};

export default Special;